export const BUY_REPORT_MESSAGES = {
    ORDER_CREATE_ERROR: "Ошибка при создании заказа",
    REPORT_CREATE_ERROR: "Ошибка при создании отчета",
    PAYMENT_DECLINED: "Платёж отклонён"
};

export const POLLING_INTERVAL = 3000;